import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';
import * as settings from "../settings";
import LowerHeroSection from '../components/LowerHeroSection';


import Testimonials from '../components/Testimonials';



export default function ArticleDetail({ isMobile }) {
    const { articlename } = useParams();
    const navigate = useNavigate();
    const [article, setArticle] = useState(null);
    const [relatedArticles, setRelatedArticles] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Use setTimeout to accommodate browser rendering/scroll-restoration quirks (e.g. Firefox)
        setTimeout(() => window.scrollTo(0, 0), 10);
        setLoading(true);
        fetch('/articles.json')
            .then(res => res.json())
            .then(data => {
                const foundArticle = data.find(a => a.slug === articlename);
                setArticle(foundArticle);

                // Filter related articles (exclude current one)
                const others = data.filter(a => a.slug !== articlename);
                // Shuffle or pick first 3
                setRelatedArticles(others.slice(0, 3));
                setLoading(false);
            })
            .catch(err => {
                console.error("Error fetching articles", err);
                setLoading(false);
            });
    }, [articlename]);

    if (loading) return <div className="text-center py-5">Loading...</div>;

    if (!article) {
        return (
            <Container className="py-5 text-center">
                <h2>Article Not Found</h2>
                <Button variant="primary" onClick={() => navigate('/article')}>Back to Articles</Button>
            </Container>
        );
    }

    return (
        <>
            {/* Hero Section */}
            <div
                className="bg-dark text-light"
                style={{
                    minHeight: '50vh',
                    backgroundImage: `
            linear-gradient(
              to bottom,
              rgba(0, 0, 0, 0.8),
              rgba(0, 0, 0, 0.6)
            ),
url(${settings.SITEURL}/hero-bg.jpg)          `,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Container>
                    <Row className="justify-content-center text-center">
                        <Col lg={10}>
                            <h1 className="display-4 fw-bold">{article.title}</h1>
                            <h2 className="lead mt-3 fs-3 text-white-50">{article.subtitle}</h2>
                        </Col>
                    </Row>
                </Container>
            </div>

            {/* Content Section */}
            <Container className="py-5" style={{ marginTop: "30px" }}>
                <Row className="justify-content-center">
                    <Col lg={8}>
                        <div
                            className="article-content fs-5 text-secondary"
                            dangerouslySetInnerHTML={{ __html: article.contentHtml }}
                        />
                    </Col>
                </Row>
            </Container>

            {/* Testimonials Section */}
            <Testimonials />


            {/* Related Content Section */}
            <Container className="py-5" style={{ marginBottom: "50px" }}>
                <div className="mb-4">
                    <h3 className="fw-bold">You Might Also Like</h3>
                    <hr />
                </div>
                <Row className="g-4">
                    {relatedArticles.map((article) => (
                        <Col key={article.id} xs={12} md={6} lg={4}>
                            <Card
                                className="h-100 shadow-sm border-0 card-hover"
                                style={{ borderRadius: '1rem', overflow: 'hidden', cursor: 'pointer' }}
                                onClick={() => navigate(`/article/${article.slug}`)}
                            >
                                <div style={{ height: '200px', overflow: 'hidden' }}>
                                    <Card.Img
                                        variant="top"
                                        src={article.image}
                                        style={{ height: '100%', objectFit: 'cover', transition: 'transform 0.3s' }}
                                    />
                                </div>
                                <Card.Body className="d-flex flex-column p-4">
                                    <div className="text-muted small mb-2">{article.date}</div>
                                    <Card.Title className="fw-bold mb-2 h5">{article.title}</Card.Title>
                                    <Card.Text className="text-secondary small">
                                        {article.summary}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </Col>
                    ))}
                </Row>
            </Container>

            {/* Call to Action Section */}
            <div className="p5" >
                <LowerHeroSection navigate={navigate} />
            </div>
        </>
    );
}
